export default {
  CHARACTER: [
    {
      text: 'Nana',
      value: 0,
    },
    {
      text: 'Maxi',
      value: 1,
    },
  ],
  ITEM_TYPE: [
    {
      text: 'Item',
      value: 0,
    },
    {
      text: 'Obstacle',
      value: 1,
    },
  ],
};
